import { memo, SVGProps, forwardRef } from 'react'
import Tooltip from 'components/Tooltip'
import Icon from 'common-components/Icon'
import * as Styled from './styled'
import { Text } from 'common-components'

interface IActionButtonProps {
  icon: React.ReactElement<SVGProps<SVGSVGElement>>
  tooltipText: string
  disabled?: boolean
  onClick: () => void
  title?: string
}

const ActionButton = forwardRef<HTMLButtonElement, IActionButtonProps>(
  ({ icon, tooltipText, disabled, onClick, title }, forwardedRef) => {
    return (
      <Tooltip tooltipText={tooltipText} ref={forwardedRef}>
        <Styled.Button
          onClick={onClick}
          $disabled={disabled}
          $hasTitle={!!title}
        >
          <Icon icon={icon} size="small" color="secondarySemiDark" />
          {title && (
            <Text type="h2" color="secondarySemiDark" lineHeight="20px">
              {title}
            </Text>
          )}
        </Styled.Button>
      </Tooltip>
    )
  }
)

ActionButton.displayName = 'ActionButton'

export default memo(ActionButton)
